import { getStores } from '@/stores'
import React, { useEffect } from 'react'

export type UseMessageUpdateFlagOptions = {
  /** messageUpdateFlag 或 syncDeps 变化时调用 */
  onChange?: (flag: number) => void
  /** 额外依赖，与 flag 一并触发回调（如 [status]） */
  syncDeps?: React.DependencyList
  /**
   * 为 true 时跳过首次挂载时的回调，仅在 flag 或 syncDeps 后续变化时触发。
   * 默认 false（挂载后首次 effect 也会执行 onChange）
   */
  skipInitialRun?: boolean
}

function useMessageUpdateFlag(messageId: string, options?: UseMessageUpdateFlagOptions): number {
  const { onChange, syncDeps = [], skipInitialRun = false } = options || {}
  const { agentV2Store } = getStores()
  const flag = agentV2Store.getMessageUpdateFlag(messageId)
  const onFlagChangeRef = React.useRef(onChange)
  onFlagChangeRef.current = onChange
  const isInitialEffectRef = React.useRef(true)

  useEffect(() => {
    if (skipInitialRun && isInitialEffectRef.current) {
      isInitialEffectRef.current = false
      return
    }
    isInitialEffectRef.current = false
    onFlagChangeRef.current?.(flag)
  }, [flag, ...syncDeps])

  return flag
}

export default useMessageUpdateFlag
